<template>
  <div class="mt-4 mb-2 justify-content-center text-center">
    <h1
      class="text-center egx-partner-color"
      :style="this.details.title.style"
      :class="this.details.title.class"
      v-if="!!this.details.title"
    >
      {{ this.details.title.text }}
    </h1>
    <h5
      class="p-4 mb-4 justify-content-center home-page-body-text"
      :style="this.details.description.style"
      :class="this.details.description.class"
      v-if="!!this.details.description"
    >
      {{ this.details.description.text }}
    </h5>
    <vue-speedometer
      v-bind="this.attributes"
      :value="value"
    />
  </div>
</template>

<script>
import VueSpeedometer from 'vue-speedometer';

export default {
  props: {
    details: Object,
    value: Number,
  },

  components: {
    VueSpeedometer,
  },

  computed: {
    attributes() {
      return this.details.attributes;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
